// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  url: 'http://appointment-tracker-prod-2-7e6ee676b827d6c3.elb.ap-south-1.amazonaws.com/tracker/api/V1/',
  stagingUrl: 'http://13.126.6.117/tracker/api/V1/',
  patientTrackerUrl: 'http://appointment-tracker-prod-2-7e6ee676b827d6c3.elb.ap-south-1.amazonaws.com/tracker/api/v1/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
